import React, { useState } from 'react';
import { Controller } from 'react-hook-form';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './style.css'

const RHFEditor = (props) => {
    const { name, id, isControlled, control, errorObj } = props;
    let isError = false;
    let errorMessage = '';

    if (errorObj && Object?.keys(errorObj)?.includes(name)) {
        isError = true
        errorMessage = errorObj[name]?.message
    }


    return <Controller
        name={name}
        control={control}
        render={({
            field
        }) => {
            return <>
                <ReactQuill
                    {...props}
                    {...field}
                    theme="snow"
                    onChange={(e) => {
                        const htmlRegexG = /<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/g;
                        const target = e.replace(htmlRegexG, "");
                        if(target !== ''){
                            field.onChange(e)
                        }else{
                            field.onChange('')
                        }
                    }}
                />
                {
                    isError ? <p className='text-[10px] pt-[2px] text-[red]' >{errorMessage}</p> : ""
                }
            </>
        }}

    />
}

export default RHFEditor